const initialState = {
  hasFetched: false,
  data: {},
  fetchError: null,
  updateError: null,
  deleteError: null,
  isPatching: false,
  showVariablePricingForm: false,
  showAttendeePricingForm: false
};

export default function calendarPricing (state = initialState, action) {
  const {
    data,
    fetchError,
    type,
    updateError,
    isPatching,
    deleteError,
    showVariablePricingForm,
    showAttendeePricingForm
  } = action;

  if ('CALENDAR_PRICING_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('CALENDAR_PRICING_FETCH_REQUEST' === type) {
    return { ...state };
  }

  if ('CALENDAR_PRICING_FETCH_SUCCESS' === type) {
    return { ...state, data, hasFetched: true };
  }

  if ('CALENDAR_PRICING_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true };
  }

  if ('CALENDAR_PRICING_UPDATE_REQUEST' === type) {
    return { ...state, isPatching };
  }

  if ('CALENDAR_PRICING_UPDATE_SUCCESS' === type) {
    return { ...state, isPatching };
  }

  if ('CALENDAR_PRICING_UPDATE_FAILURE' === type) {
    return { ...state, updateError, isPatching };
  }

  if ('CALENDAR_PRICING_DELETE_REQUEST' === type) {
    return { ...state, isPatching };
  }

  if ('CALENDAR_PRICING_DELETE_SUCCESS' === type) {
    return { ...state, isPatching };
  }

  if ('CALENDAR_PRICING_DELETE_FAILURE' === type) {
    return { ...state, deleteError, isPatching };
  }

  if ('SHOW_VARIABLE_PRICING_FORM' === type) {
    return { ...state, showVariablePricingForm };
  }

  if ('SHOW_VARIABLE_ATTENDEE_FORM' === type) {
    return { ...state, showAttendeePricingForm };
  }

  return state;
}
